var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.1155186mm",
    height: "3.2210042mm",
    viewBox: "0 0 8.1155186 3.2210042",
    id: "svg1470",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1464"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.00926355,0,0,0.00926355,70.781527,144.1991)",
    gradientUnits: "userSpaceOnUse",
    y2: 193.55,
    x2: 198.19,
    y1: 126.42,
    x1: -8.4200001,
    id: "linear-gradient-2-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2437",
    stopColor: "#9e07ae",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2439",
    stopColor: "#e5202f",
    offset: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.00926355,0,0,0.00926355,70.781527,144.1991)",
    gradientUnits: "userSpaceOnUse",
    y2: 221.32001,
    x2: 286.07999,
    y1: 154.06,
    x1: 79.07,
    id: "linear-gradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2432",
    stopColor: "#faa51a",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2434",
    stopColor: "#f06424",
    offset: 0.92
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-70.781527,-144.19885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Opta-8",
    transform: "matrix(0.00926355,0,0,0.00926355,70.781527,144.1991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2444",
    d: "m 597.66,125.45 q -31.56,0 -52.23,8 l -10.6,3.88 v 183.33 h 39 v -55.33 a 105.85,105.85 0 0 0 20.42,2.32 q 29.73,0 44.73,-14.35 15,-14.35 15,-41.75 V 179 q 0,-25.84 -13.83,-39.69 -13.83,-13.85 -42.49,-13.86 z m 17.06,86.1 q 0,21.19 -23.53,21.2 a 113.14,113.14 0 0 1 -17.32,-1.55 v -68.78 l 1.55,-0.26 a 63.81,63.81 0 0 1 8.79,-1.42 q 4.39,-0.39 8.79,-0.39 21.72,0 21.72,18.88 z",
    className: "cls-1",
    style: {
      fill: "#222222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2446",
    d: "m 741.09,164 11.5,-34.65 h -32.33 v -31 h -39 v 31 H 658 V 164 h 23.27 v 45 q 0,17.6 3.62,28.83 3.62,11.23 11.11,17.8 7.49,6.6 19.52,9.18 a 137.76,137.76 0 0 0 28.57,2.59 h 6.16 v -35.94 h -6.16 a 51.45,51.45 0 0 1 -11.25,-1 15.3,15.3 0 0 1 -7.37,-3.75 14.88,14.88 0 0 1 -4,-7.37 50.55,50.55 0 0 1 -1.16,-11.89 V 164 Z",
    className: "cls-1",
    style: {
      fill: "#222222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    d: "m 818.38,125.45 q -40.86,0 -55.33,26.89 l -3.88,7.5 32.32,13.44 4.14,-5.43 q 7.23,-9.56 21.46,-9.56 19.9,0 19.91,19.13 v 5.69 q -4.14,-0.26 -8.67,-0.39 c -3,-0.08 -6.25,-0.13 -9.69,-0.13 a 151.14,151.14 0 0 0 -27.8,2.2 q -11.51,2.19 -18.61,7.11 A 28.89,28.89 0 0 0 761.76,205 q -3.37,8.14 -3.36,20 a 55.19,55.19 0 0 0 3,19 28.54,28.54 0 0 0 9.82,13.31 q 6.85,5.18 18.23,7.76 11.38,2.58 28.18,2.58 33.36,0 48.87,-7 c 0.34,-0.17 1,-0.47 1.94,-0.9 0.94,-0.43 2,-0.91 3.23,-1.42 q 2.07,-1 4.4,-2.07 V 180 Q 876,125.46 818.38,125.45 Z m 18.62,110.66 -2.33,0.26 a 82.72,82.72 0 0 1 -8.27,0.78 q -4.92,0.25 -11.64,0.25 -10.08,0 -13.7,-3.23 -3.62,-3.23 -3.62,-9.44 0,-5.94 3.75,-9.17 3.75,-3.23 14.09,-3.24 c 1,0 2.62,0.05 4.78,0.13 2.16,0.08 4.4,0.13 6.72,0.13 2.32,0 4.48,0 6.47,0.13 1.99,0.13 3.23,0.13 3.75,0.13 z",
    className: "cls-1",
    style: {
      fill: "#222222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2450-8",
    d: "M 503,94.71 Q 483.06,76.4 446.42,76.39 q -36.39,0 -56.27,18.32 -19.88,18.32 -19.87,51.11 V 198 q 0,32.79 19.87,51.11 19.87,18.32 56.27,18.32 36.65,0 56.53,-18.32 19.88,-18.32 19.87,-51.11 V 145.82 Q 522.82,113 503,94.71 Z m -22.2,104 q 0,30.2 -34.33,30.2 -16.51,0 -25.29,-7.62 -8.78,-7.62 -8.78,-22.58 V 145 q 0,-15 8.78,-22.58 8.78,-7.58 25.29,-7.61 34.32,0 34.33,30.19 z",
    className: "cls-1",
    style: {
      fill: "#222222"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-7)",
      strokeWidth: 0.00926355
    },
    id: "path2453",
    d: "m 73.018674,144.50813 a 1.0453915,1.0453915 0 0 0 -0.304401,-0.19388 l -0.211857,0.63807 a 0.34571567,0.34571567 0 0 1 0.06401,0.0463 c 0.03298,0.0304 0.120426,0.11116 0.120426,0.37156 v 0.87892 c 0,0.26049 -0.08736,0.34109 -0.120426,0.37147 -0.118573,0.1094 -0.337934,0.13238 -0.500973,0.13238 a 1.500695,1.500695 0 0 1 -0.158314,-0.008 l -0.213061,0.64177 a 1.9624829,1.9624829 0 0 0 0.371375,0.0331 q 0.617879,0 0.953127,-0.30903 0.335248,-0.30903 0.335155,-0.86151 v -0.87948 q 9.3e-5,-0.55276 -0.335062,-0.86179 z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-2-3)",
      strokeWidth: 0.00926355
    },
    id: "path2455",
    d: "m 71.568928,146.62041 c -0.03279,-0.0303 -0.120426,-0.11117 -0.120426,-0.37129 v -0.8792 c 0,-0.26049 0.08735,-0.34108 0.120426,-0.37147 0.09514,-0.0878 0.262251,-0.13237 0.496619,-0.13237 0.04687,0 0.09838,0.002 0.150811,0.007 l 0.213061,-0.64289 a 1.9916631,1.9916631 0 0 0 -0.363872,-0.0313 q -0.613803,0 -0.948865,0.30903 -0.335063,0.30903 -0.335155,0.86179 v 0.8792 q 0,0.55276 0.335155,0.86151 a 1.0467811,1.0467811 0 0 0 0.293747,0.18972 l 0.212413,-0.63974 a 0.35423814,0.35423814 0 0 1 -0.05391,-0.0402 z",
    className: "cls-3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpta);
export default __webpack_public_path__ + "static/media/opta.5e44f25c53741fcaedbc371973c27d65.svg";
export { ForwardRef as ReactComponent };